<template>
    <div    class="">
        <device-profile-template-show   v-model:show="profileTemplateShow"
                                        :device-profile="currentProfile"

        ></device-profile-template-show>

        <!-- Table -->
        <ajax-table     :data="characteristics"
                        :headers="headers"
                        v-model:loading="ajaxTable.loading"
                        v-model:search="ajaxTable.search"
                        v-model:sort-by="ajaxTable.sortBy"
                        v-model:sort-desc="ajaxTable.sortDesc"
                        v-model:page="ajaxTable.page"
                        v-model:items-per-page="ajaxTable.itemsPerPage"
                        v-model:page-info="ajaxTable.pageInfo"
                        :exportable="false"
                        @loadData="getData"
                        :row-selectable="false"
        >

            <template   #items-per-page>
                <div    v-show="currentProfile"
                        class="flex justify-end items-center "
                >
                    <button-blue-secondary  v-if="hasProfileTemplate"
                                            @click="toggleProfileTemplate">
                        Profile Template - {{ currentProfile.title }}
                    </button-blue-secondary>
                </div>
            </template>
            <template   #col-1="props">
                {{ props.row.uuidDisplay }}
            </template>
            <template   #col-2="props">
                {{ props.row.prettyDuoValue }}
            </template>
            <template   #col-3="props">
                {{ props.row.prettyTemplateValue }}
            </template>
            <template   #col-4="props">
                {{ props.row.updatedBy.display_name}}
            </template>
            <template   #col-5="props">
                {{ props.row.updatedOn }}
            </template>
        </ajax-table>
    </div>
</template>

<script>
import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import AjaxTable from "@/components/elements/AjaxTable";
import {ajaxTableMixin} from "@/mixins/ajaxTableMixin";
import DeviceProfileTemplateShow from "@/components/DeviceProfileTemplate/DeviceProfileTemplateShow";
import SonicuButton from "@/components/elements/buttons/SonicuButton";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";

export default {
    name: "ProfileChanged",
    mixins: [SonicuCoreMixin, iconNamesMixin, ajaxTableMixin],
    components: {ButtonBlueSecondary, SonicuButton, DeviceProfileTemplateShow, AjaxTable},
    props: {
        pointSerial: String,
    },
    data() {
        return {
            currentProfile: {},
            profileTemplateShow: false,

            characteristics: [],
            headers: [
                {
                    name: 'Characteristics',
                    sortBy: 'characteristic',
                },
                {
                    name: 'Duo Value',
                    sortBy: '',
                },
                {
                    name: 'Template Value',
                    sortBy: '',
                },
                {
                    name: 'Updated By',
                    sortBy: 'updated-by',
                    show: 'lg',
                },
                {
                    name: 'Updated On',
                    sortBy: 'updated-on',
                    show: 'lg',
                },
            ],
        }
    },
    created() {
        
    },
    mounted() {
        
    },
    methods: {
        getData() {
            this.characteristics = []
            this.currentProfile = {}
            this.ajaxTable.loading = true
            this.ajaxTable.requestNumber++
            let params = this.ajaxTable
            axios.get(this.company.buildCompanyApiInternalRoute(`device-profile-changed/${this.pointSerial}`), {
                params: params,
            }).then(response => {
                let data = response.data
                if (`${this.ajaxTable.requestNumber}` !== data.meta.requestNumber) {
                    return
                }
                this.characteristics = data.data
                this.currentProfile = data.meta.profileTemplate
                this.currentProfile.active = this.currentProfile.active === 1

            }).catch(error => {
            }).then(() => {
                this.ajaxTable.loading = false
            })
        },
        toggleProfileTemplate() {
            console.log("Toggling Profile")
            if (this.hasProfileTemplate) {
                this.profileTemplateShow = !this.profileTemplateShow
            }
        },
    },
    computed: {
        hasProfileTemplate() {
            return Object.keys(this.currentProfile).length > 0
        },
    },
    watch: {
        pointSerial() {
            this.getData()
        },
    },
}
</script>

<style scoped>

</style>